import styled from 'styled-components'
import { theme } from '../styles/GlobalStyle'
import bg from '../assets/images/bg.jpg'

const PricesStyle = styled.div`
  background-color: ${theme.dark};
  background-image: linear-gradient(
      to bottom,
      rgba(13, 29, 48, 0.54) 0%,
      rgba(13, 29, 48, 0.54) 100%
    ),
    url(${bg});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  min-height: 530px;

  .container {
    padding-top: 6.3vw;
    padding-bottom: 6.3vw;
    display: flex;
    justify-content: space-around;

    max-width: 990px;
  }

  h1 {
    font-family: Ubuntu-Bold, sans-serif;
    font-size: 96px;
    font-weight: bold;
    line-height: 1.33;
    color: #fff;
  }
  h3 {
    font-size: 24px;
    font-weight: 300;
    line-height: 1.5;
    color: #fff;
    padding-bottom: 18px;
  }

  p {
    opacity: 0.6;
    font-size: 14px;
    line-height: 1.71;
    letter-spacing: 0.5px;
    color: white;
  }
  .column {
    max-width: 314px;
  }

  .price {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    min-height: 260px;
  }

  @media (max-width: 767px) {
    .container {
      flex-direction: column;
      align-items: center;
    }

    .column {
      text-align: center;
    }
    .column:nth-child(1) {
      margin-bottom: 11.3vw;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 19.3vw;
    }
  }
`
export default PricesStyle
